// action type
export const ActyonType = {
    SAVE: 'ITEM_SAVE',
};
const initialState = {
    item: undefined,
};
// reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ActyonType.SAVE:
            return {
                ...state,
                item: action.item,
            };
        default:
            return state;
    }
}
